import { render } from "./courtOrderList.vue?vue&type=template&id=5b958850"
import script from "./courtOrderList.vue?vue&type=script&lang=js"
export * from "./courtOrderList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__